import type { ReactNode } from "react";

/**
 * Desktop-monitor frame (dark bezel + stand) used to present product screenshots.
 * Originally the Alcatraz hero mockup; extracted so the home Operations section can
 * reuse the exact same chassis. `children` render as an overlay above the screen for
 * floating callouts — the figure is the positioning context.
 */
export function MonitorMockup({
  image,
  alt,
  aspectClass = "aspect-[15/11]",
  priority = false,
  className,
  children,
}: {
  image: string;
  alt: string;
  aspectClass?: string;
  priority?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <figure className={`relative mx-auto max-w-[720px] ${className ?? ""}`}>
      <div aria-hidden className="absolute -inset-8 -z-10 rounded-full bg-primary/15 blur-3xl" />
      <div className="relative">
        <div className="rounded-[1.35rem] border border-foreground/15 bg-foreground p-2 shadow-2xl shadow-primary/15">
          <div className="rounded-[1rem] border border-white/10 bg-[#101827] p-1.5">
            <div className="overflow-hidden rounded-[0.65rem] bg-[#101827]">
              <img
                src={image}
                alt={alt}
                loading={priority ? "eager" : "lazy"}
                decoding="async"
                className={`block w-full object-cover object-top ${aspectClass}`}
              />
            </div>
          </div>
        </div>
        <div
          aria-hidden
          className="mx-auto h-10 w-[26%] bg-gradient-to-b from-foreground/80 to-foreground/15"
        />
        <div
          aria-hidden
          className="mx-auto h-3 w-[46%] rounded-full bg-foreground/20 shadow-xl shadow-primary/10"
        />
      </div>
      {children}
      <figcaption className="sr-only">{alt}</figcaption>
    </figure>
  );
}
